import {FixedDropDownButton, Icon} from 'mc/lib';
import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {DropdownItem} from 'reactstrap';
import {postNavigateToParkovaciKartaMessage, postNavigateToZadostMessage} from '../../utils/messageUtils';

class ZadostActionsMenu extends PureComponent {

    static propTypes = {
        zadost: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    handleNavigateToZadost = () => {
        const {zadost, history} = this.props;
        history.push('/zadost/' + zadost.id);
    };

    handleNavigateToVaadinZadost = () => {
        const {zadost} = this.props;
        postNavigateToZadostMessage(zadost.id);
    };

    handleNavigateToVaadinParkovacikarta = () => {
        const {zadost} = this.props;
        postNavigateToParkovaciKartaMessage(zadost.id);
    };

    render() {
        const {zadost} = this.props;
        return (
            <FixedDropDownButton title={<Icon icon="ellipsis-v"/>} color="action action-hover" noCaret>
                <DropdownItem onClick={this.handleNavigateToZadost}>Přehled vyrovnání</DropdownItem>
                <DropdownItem onClick={this.handleNavigateToVaadinZadost}>Detail žádosti</DropdownItem>
                {zadost.drzitel && (
                    <DropdownItem onClick={this.handleNavigateToVaadinParkovacikarta}>Karta držitele</DropdownItem>
                )}
            </FixedDropDownButton>
        );
    }
}

export default withRouter(connect()(ZadostActionsMenu));
